"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[818],{

/***/ 38391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AlertTitle_AlertTitle; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(81719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(78884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/AlertTitle/alertTitleClasses.js

function getAlertTitleUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiAlertTitle', slot);
}
const alertTitleClasses = (0,generateUtilityClasses/* default */.Z)('MuiAlertTitle', ['root']);
/* harmony default export */ var AlertTitle_alertTitleClasses = ((/* unused pure expression or super */ null && (alertTitleClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/AlertTitle/AlertTitle.js


const _excluded = ["className"];










const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getAlertTitleUtilityClass, classes);
};

const AlertTitleRoot = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  name: 'MuiAlertTitle',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => {
  return {
    fontWeight: theme.typography.fontWeightMedium,
    marginTop: -2
  };
});
const AlertTitle = /*#__PURE__*/react.forwardRef(function AlertTitle(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiAlertTitle'
  });

  const {
    className
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = props;
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AlertTitleRoot, (0,esm_extends/* default */.Z)({
    gutterBottom: true,
    component: "div",
    ownerState: ownerState,
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var AlertTitle_AlertTitle = (AlertTitle);

/***/ }),

/***/ 45343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bz": function() { return /* binding */ LoginType; },
/* harmony export */   "IX": function() { return /* binding */ ShowDetails; },
/* harmony export */   "LC": function() { return /* binding */ PackingAction; },
/* harmony export */   "Pf": function() { return /* binding */ PackingState; }
/* harmony export */ });

var LoginType;
(function(LoginType) {
    LoginType[/** Agents */ "AGENTE"] = "AGENTE";
    LoginType[/** AS400 User */ "AS400"] = "AS400";
    LoginType[/** Clients */ "CLIENTE"] = "CLIENTE";
    LoginType[/** Employee */ "EMPLEADO"] = "EMPLEADO";
    LoginType[/** Intranet */ "INTRANET"] = "INTRANET";
    LoginType[/** AS400 */ "LOGIN_400"] = "LOGIN_400";
    LoginType[/** Mayoral Workshops */ "TALLER"] = "TALLER";
    LoginType[/** Boston Workshops */ "TALLERB"] = "TALLERB";
    LoginType["TALLERB_R"] = "TALLERB_R";
    LoginType[/** Missa Workshops */ "TALLERM"] = "TALLERM";
    LoginType["TALLERM_R"] = "TALLERM_R";
    LoginType["TALLER_R"] = "TALLER_R";
    LoginType[/** Mayoral Shops */ "TIENDA"] = "TIENDA";
    LoginType[/** Boston Shops */ "TIENDAB"] = "TIENDAB";
    LoginType[/** Mayoral Online */ "USER_ON"] = "USER_ON";
    LoginType[/** WSC */ "WSC"] = "WSC";
})(LoginType || (LoginType = {}));
var PackingAction;
(function(PackingAction) {
    PackingAction["A"] = "A";
    PackingAction["D"] = "D";
    PackingAction["U"] = "U";
})(PackingAction || (PackingAction = {}));
var PackingState;
(function(PackingState) {
    PackingState["A"] = "A";
    PackingState["C"] = "C";
    PackingState["I"] = "I";
})(PackingState || (PackingState = {}));
var ShowDetails;
(function(ShowDetails) {
    ShowDetails["N"] = "N";
    ShowDetails["S"] = "S";
})(ShowDetails || (ShowDetails = {}));


/***/ }),

/***/ 18491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ login_LoginView; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/ui/Brand/index.ts + 2 modules
var Brand = __webpack_require__(25314);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(81719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mayoral/ui/Dropdown/Dropdown.tsx
var Dropdown = __webpack_require__(21115);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 26 modules
var esm = __webpack_require__(37778);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/login/LoginLangDropdown/LoginLangDropdown.tsx






var LangDropdown = (0,styled/* default */.ZP)(Dropdown/* Dropdown */.L, {
    name: "LoginLangDropdown",
    slot: "Root"
})({
    fontSize: 14,
    height: 37,
    top: "3px"
});
var LoginLangDropdown = function(param) {
    var _manager = param.manager, manager = _manager === void 0 ? false : _manager;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)().t;
    var locale = router.locale, locales = router.locales;
    var options = locales.map(function(value) {
        return {
            label: t(value.toUpperCase()),
            value: value
        };
    });
    var handleChange = function(e) {
        var value = e.target.value;
        var path = manager ? "/login/manager" : "/login";
        router.push(path, path, {
            locale: value
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LangDropdown, {
        value: locale,
        options: options,
        onChange: handleChange,
        MenuProps: {
            PaperProps: {
                style: {
                    maxHeight: 260
                }
            }
        }
    });
};
/* harmony default export */ var LoginLangDropdown_LoginLangDropdown = (LoginLangDropdown);

;// CONCATENATED MODULE: ./src/components/login/LoginLangDropdown/index.ts


// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./src/lib/graphql/cache.ts + 10 modules
var graphql_cache = __webpack_require__(53300);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(17283);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
;// CONCATENATED MODULE: ./node_modules/@mayoral/sdk/core/auth/__generated__/login.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation Login($type: LoginType!, $username: String!, $password: String!) {\n    login(type: $type, username: $username, password: $password) {\n      token\n      refreshToken\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var defaultOptions = {};
var LoginDocument = (0,lib/* gql */.Ps)(_templateObject());
/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      type: // value for 'type'
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */ function useLoginMutation(baseOptions) {
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, baseOptions);
    return useMutation/* useMutation */.D(LoginDocument, options);
}

;// CONCATENATED MODULE: ./node_modules/@mayoral/sdk/core/customer/__generated__/customer.ts


function customer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Customer {\n    customer {\n      username\n      firstName\n      lastName\n      email\n      loggedIn @client\n    }\n  }\n"
    ]);
    customer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var customer_defaultOptions = {};
var CustomerDocument = (0,lib/* gql */.Ps)(customer_templateObject());
/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *   },
 * });
 */ function useCustomerQuery(baseOptions) {
    var options = _object_spread({}, customer_defaultOptions, baseOptions);
    return Apollo.useQuery(CustomerDocument, options);
}
function useCustomerLazyQuery(baseOptions) {
    var options = _object_spread({}, customer_defaultOptions, baseOptions);
    return Apollo.useLazyQuery(CustomerDocument, options);
}

// EXTERNAL MODULE: ./src/lib/utils/cookies.ts + 1 modules
var cookies = __webpack_require__(15268);
// EXTERNAL MODULE: ./src/lib/constants/index.ts + 5 modules
var constants = __webpack_require__(43710);
;// CONCATENATED MODULE: ./src/lib/graphql/hooks/useLogin.ts





/**
 * Wrapper for auto-generated useLoginMutation to globally handle cache / storage when logging in.
 */ var useLogin = function() {
    var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return useLoginMutation((0,src_object_spread/* default */.Z)({
        awaitRefetchQueries: true,
        refetchQueries: [
            {
                query: CustomerDocument
            }, 
        ],
        update: function(cache, param) {
            var data = param.data;
            var _login = data.login, token = _login.token, refreshToken = _login.refreshToken;
            (0,cookies/* writeToCookies */.kD)(constants/* StorageTokens.TOKEN */.Gr.TOKEN, token, {
                expires: constants/* AuthCookieExpiration */.JG
            });
            (0,cookies/* writeToCookies */.kD)(constants/* StorageTokens.REFRESH_TOKEN */.Gr.REFRESH_TOKEN, refreshToken, {
                expires: constants/* AuthCookieExpiration */.JG
            });
            (0,graphql_cache/* loggedInVar */.AL)(true);
        }
    }, opts));
};
/* harmony default export */ var hooks_useLogin = (useLogin);

// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/@mayoral/ui/Icon/Icon.tsx
var Icon = __webpack_require__(77166);
// EXTERNAL MODULE: ./node_modules/@mayoral/ui/TextField/TextField.tsx + 1 modules
var TextField = __webpack_require__(86440);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/internal/SwitchBase.js + 1 modules
var SwitchBase = __webpack_require__(37743);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(54235);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/internal/svg-icons/CheckBoxOutlineBlank.js


/**
 * @ignore - internal component.
 */


/* harmony default export */ var CheckBoxOutlineBlank = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/internal/svg-icons/CheckBox.js


/**
 * @ignore - internal component.
 */


/* harmony default export */ var CheckBox = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox'));
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/internal/svg-icons/IndeterminateCheckBox.js


/**
 * @ignore - internal component.
 */


/* harmony default export */ var IndeterminateCheckBox = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox'));
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/capitalize.js
var capitalize = __webpack_require__(36622);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(78884);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Checkbox/checkboxClasses.js

function getCheckboxUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCheckbox', slot);
}
const checkboxClasses = (0,generateUtilityClasses/* default */.Z)('MuiCheckbox', ['root', 'checked', 'disabled', 'indeterminate', 'colorPrimary', 'colorSecondary']);
/* harmony default export */ var Checkbox_checkboxClasses = (checkboxClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Checkbox/Checkbox.js


const _excluded = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size", "className"];
















const useUtilityClasses = ownerState => {
  const {
    classes,
    indeterminate,
    color
  } = ownerState;
  const slots = {
    root: ['root', indeterminate && 'indeterminate', `color${(0,capitalize/* default */.Z)(color)}`]
  };
  const composedClasses = (0,composeClasses/* default */.Z)(slots, getCheckboxUtilityClass, classes);
  return (0,esm_extends/* default */.Z)({}, classes, composedClasses);
};

const CheckboxRoot = (0,styled/* default */.ZP)(SwitchBase/* default */.Z, {
  shouldForwardProp: prop => (0,styled/* rootShouldForwardProp */.FO)(prop) || prop === 'classes',
  name: 'MuiCheckbox',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.indeterminate && styles.indeterminate, ownerState.color !== 'default' && styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  color: (theme.vars || theme).palette.text.secondary
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator/* alpha */.Fq)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.color !== 'default' && {
  [`&.${Checkbox_checkboxClasses.checked}, &.${Checkbox_checkboxClasses.indeterminate}`]: {
    color: (theme.vars || theme).palette[ownerState.color].main
  },
  [`&.${Checkbox_checkboxClasses.disabled}`]: {
    color: (theme.vars || theme).palette.action.disabled
  }
}));

const defaultCheckedIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(CheckBox, {});

const defaultIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(CheckBoxOutlineBlank, {});

const defaultIndeterminateIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(IndeterminateCheckBox, {});

const Checkbox = /*#__PURE__*/react.forwardRef(function Checkbox(inProps, ref) {
  var _icon$props$fontSize, _indeterminateIcon$pr;

  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCheckbox'
  });

  const {
    checkedIcon = defaultCheckedIcon,
    color = 'primary',
    icon: iconProp = defaultIcon,
    indeterminate = false,
    indeterminateIcon: indeterminateIconProp = defaultIndeterminateIcon,
    inputProps,
    size = 'medium',
    className
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const icon = indeterminate ? indeterminateIconProp : iconProp;
  const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    indeterminate,
    size
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckboxRoot, (0,esm_extends/* default */.Z)({
    type: "checkbox",
    inputProps: (0,esm_extends/* default */.Z)({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: /*#__PURE__*/react.cloneElement(icon, {
      fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
    }),
    checkedIcon: /*#__PURE__*/react.cloneElement(indeterminateIcon, {
      fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
    }),
    ownerState: ownerState,
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, other, {
    classes: classes
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx = __webpack_require__(86523);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/sx/sx.js


function sx(styles) {
  return ({
    theme
  }) => (0,styleFunctionSx/* default */.Z)({
    sx: styles,
    theme
  });
}

/* harmony default export */ var sx_sx = (sx);
;// CONCATENATED MODULE: ./node_modules/@mayoral/ui/Checkbox/Checkbox.parts.tsx





var CheckboxBox = (0,styled/* default */.ZP)(Box/* default */.Z, {
    name: "Checkbox",
    slot: "Box",
    shouldForwardProp: function(prop) {
        return prop !== "checked" && prop !== "sx";
    },
    overridesResolver: function(props, styles) {
        return [
            styles.root,
            props.checked && styles.checked
        ];
    }
})(function(param) {
    var checked = param.checked;
    return sx_sx((0,src_object_spread/* default */.Z)({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 16,
        height: 16,
        color: "common.white",
        bgcolor: "common.white",
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: "dark.200",
        "input:hover ~ &": {
            borderColor: "dark.400"
        },
        "input:disabled ~ &": {
            color: "dark.200",
            backgroundColor: "dark.100",
            borderColor: "dark.100"
        }
    }, checked && {
        bgcolor: "primary.main",
        borderColor: "primary.main",
        "input:hover ~ &": {
            backgroundColor: "primary.dark",
            borderColor: "transparent"
        },
        "input:disabled ~ &": {
            color: "dark.200",
            backgroundColor: "dark.100",
            borderColor: "transparent"
        }
    }));
});
var CheckedIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxBox, {
        checked: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
            name: "CheckXS",
            sx: {
                fontSize: 10,
                path: {
                    fill: "currentColor"
                }
            },
            viewBox: "0 0 8 8"
        })
    });
};
var NonCheckedIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxBox, {
        checked: false
    });
};
var IndeterminateIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxBox, {
        checked: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
            name: "MinusXS",
            sx: {
                fontSize: 10,
                path: {
                    fill: "currentColor"
                }
            },
            viewBox: "0 0 8 8"
        })
    });
};

;// CONCATENATED MODULE: ./node_modules/@mayoral/ui/Checkbox/Checkbox.tsx





var Checkbox_Checkbox_Checkbox = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_Checkbox, (0,src_object_spread/* default */.Z)({
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(NonCheckedIcon, {}),
        checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckedIcon, {}),
        indeterminateIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IndeterminateIcon, {})
    }, props));
};

// EXTERNAL MODULE: ./node_modules/@mayoral/ui/Button/Button.tsx + 2 modules
var Button = __webpack_require__(93569);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useForkRef.js
var useForkRef = __webpack_require__(30067);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useEventCallback.js
var useEventCallback = __webpack_require__(73633);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ownerDocument.js
var ownerDocument = __webpack_require__(57094);
;// CONCATENATED MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js


 // TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1



function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}

function clickedRootScrollbar(event, doc) {
  return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}

/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/base/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base/api/click-away-listener/)
 */
function ClickAwayListener(props) {
  const {
    children,
    disableReactTree = false,
    mouseEvent = 'onClick',
    onClickAway,
    touchEvent = 'onTouchEnd'
  } = props;
  const movedRef = react.useRef(false);
  const nodeRef = react.useRef(null);
  const activatedRef = react.useRef(false);
  const syntheticEventRef = react.useRef(false);
  react.useEffect(() => {
    // Ensure that this component is not "activated" synchronously.
    // https://github.com/facebook/react/issues/20074
    setTimeout(() => {
      activatedRef.current = true;
    }, 0);
    return () => {
      activatedRef.current = false;
    };
  }, []);
  const handleRef = (0,useForkRef/* default */.Z)( // @ts-expect-error TODO upstream fix
  children.ref, nodeRef); // The handler doesn't take event.defaultPrevented into account:
  //
  // event.preventDefault() is meant to stop default behaviors like
  // clicking a checkbox to check it, hitting a button to submit a form,
  // and hitting left arrow to move the cursor in a text input etc.
  // Only special HTML elements have these default behaviors.

  const handleClickAway = (0,useEventCallback/* default */.Z)(event => {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false;
    const doc = (0,ownerDocument/* default */.Z)(nodeRef.current); // 1. IE11 support, which trigger the handleClickAway even after the unbind
    // 2. The child might render null.
    // 3. Behave like a blur listener.

    if (!activatedRef.current || !nodeRef.current || 'clientX' in event && clickedRootScrollbar(event, doc)) {
      return;
    } // Do not act if user performed touchmove


    if (movedRef.current) {
      movedRef.current = false;
      return;
    }

    let insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js

    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      insideDOM = !doc.documentElement.contains( // @ts-expect-error returns `false` as intended when not dispatched from a Node
      event.target) || nodeRef.current.contains( // @ts-expect-error returns `false` as intended when not dispatched from a Node
      event.target);
    }

    if (!insideDOM && (disableReactTree || !insideReactTree)) {
      onClickAway(event);
    }
  }); // Keep track of mouse/touch events that bubbled up through the portal.

  const createHandleSynthetic = handlerName => event => {
    syntheticEventRef.current = true;
    const childrenPropsHandler = children.props[handlerName];

    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };

  const childrenProps = {
    ref: handleRef
  };

  if (touchEvent !== false) {
    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
  }

  react.useEffect(() => {
    if (touchEvent !== false) {
      const mappedTouchEvent = mapEventPropToEvent(touchEvent);
      const doc = (0,ownerDocument/* default */.Z)(nodeRef.current);

      const handleTouchMove = () => {
        movedRef.current = true;
      };

      doc.addEventListener(mappedTouchEvent, handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return () => {
        doc.removeEventListener(mappedTouchEvent, handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }

    return undefined;
  }, [handleClickAway, touchEvent]);

  if (mouseEvent !== false) {
    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
  }

  react.useEffect(() => {
    if (mouseEvent !== false) {
      const mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      const doc = (0,ownerDocument/* default */.Z)(nodeRef.current);
      doc.addEventListener(mappedMouseEvent, handleClickAway);
      return () => {
        doc.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }

    return undefined;
  }, [handleClickAway, mouseEvent]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: /*#__PURE__*/react.cloneElement(children, childrenProps)
  });
}

 false ? 0 : void 0;

if (false) {}

/* harmony default export */ var ClickAwayListener_ClickAwayListener = (ClickAwayListener);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/useEventCallback.js
var utils_useEventCallback = __webpack_require__(26432);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grow/Grow.js
var Grow = __webpack_require__(61760);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(70918);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/SnackbarContent/snackbarContentClasses.js

function getSnackbarContentUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiSnackbarContent', slot);
}
const snackbarContentClasses = (0,generateUtilityClasses/* default */.Z)('MuiSnackbarContent', ['root', 'message', 'action']);
/* harmony default export */ var SnackbarContent_snackbarContentClasses = ((/* unused pure expression or super */ null && (snackbarContentClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/SnackbarContent/SnackbarContent.js


const SnackbarContent_excluded = ["action", "className", "message", "role"];












const SnackbarContent_useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    action: ['action'],
    message: ['message']
  };
  return (0,composeClasses/* default */.Z)(slots, getSnackbarContentUtilityClass, classes);
};

const SnackbarContentRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiSnackbarContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => {
  const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
  const backgroundColor = (0,colorManipulator/* emphasize */._4)(theme.palette.background.default, emphasis);
  return (0,esm_extends/* default */.Z)({}, theme.typography.body2, {
    color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
    backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: '6px 16px',
    borderRadius: (theme.vars || theme).shape.borderRadius,
    flexGrow: 1,
    [theme.breakpoints.up('sm')]: {
      flexGrow: 'initial',
      minWidth: 288
    }
  });
});
const SnackbarContentMessage = (0,styled/* default */.ZP)('div', {
  name: 'MuiSnackbarContent',
  slot: 'Message',
  overridesResolver: (props, styles) => styles.message
})({
  padding: '8px 0'
});
const SnackbarContentAction = (0,styled/* default */.ZP)('div', {
  name: 'MuiSnackbarContent',
  slot: 'Action',
  overridesResolver: (props, styles) => styles.action
})({
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto',
  paddingLeft: 16,
  marginRight: -8
});
const SnackbarContent = /*#__PURE__*/react.forwardRef(function SnackbarContent(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiSnackbarContent'
  });

  const {
    action,
    className,
    message,
    role = 'alert'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, SnackbarContent_excluded);

  const ownerState = props;
  const classes = SnackbarContent_useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SnackbarContentRoot, (0,esm_extends/* default */.Z)({
    role: role,
    square: true,
    elevation: 6,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SnackbarContentMessage, {
      className: classes.message,
      ownerState: ownerState,
      children: message
    }), action ? /*#__PURE__*/(0,jsx_runtime.jsx)(SnackbarContentAction, {
      className: classes.action,
      ownerState: ownerState,
      children: action
    }) : null]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var SnackbarContent_SnackbarContent = (SnackbarContent);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Snackbar/snackbarClasses.js

function getSnackbarUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiSnackbar', slot);
}
const snackbarClasses = (0,generateUtilityClasses/* default */.Z)('MuiSnackbar', ['root', 'anchorOriginTopCenter', 'anchorOriginBottomCenter', 'anchorOriginTopRight', 'anchorOriginBottomRight', 'anchorOriginTopLeft', 'anchorOriginBottomLeft']);
/* harmony default export */ var Snackbar_snackbarClasses = ((/* unused pure expression or super */ null && (snackbarClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Snackbar/Snackbar.js


const Snackbar_excluded = ["onEnter", "onExited"],
      _excluded2 = ["action", "anchorOrigin", "autoHideDuration", "children", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onBlur", "onClose", "onFocus", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"];















const Snackbar_useUtilityClasses = ownerState => {
  const {
    classes,
    anchorOrigin
  } = ownerState;
  const slots = {
    root: ['root', `anchorOrigin${(0,capitalize/* default */.Z)(anchorOrigin.vertical)}${(0,capitalize/* default */.Z)(anchorOrigin.horizontal)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getSnackbarUtilityClass, classes);
};

const SnackbarRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiSnackbar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`anchorOrigin${(0,capitalize/* default */.Z)(ownerState.anchorOrigin.vertical)}${(0,capitalize/* default */.Z)(ownerState.anchorOrigin.horizontal)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  const center = {
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  };
  return (0,esm_extends/* default */.Z)({
    zIndex: (theme.vars || theme).zIndex.snackbar,
    position: 'fixed',
    display: 'flex',
    left: 8,
    right: 8,
    justifyContent: 'center',
    alignItems: 'center'
  }, ownerState.anchorOrigin.vertical === 'top' ? {
    top: 8
  } : {
    bottom: 8
  }, ownerState.anchorOrigin.horizontal === 'left' && {
    justifyContent: 'flex-start'
  }, ownerState.anchorOrigin.horizontal === 'right' && {
    justifyContent: 'flex-end'
  }, {
    [theme.breakpoints.up('sm')]: (0,esm_extends/* default */.Z)({}, ownerState.anchorOrigin.vertical === 'top' ? {
      top: 24
    } : {
      bottom: 24
    }, ownerState.anchorOrigin.horizontal === 'center' && center, ownerState.anchorOrigin.horizontal === 'left' && {
      left: 24,
      right: 'auto'
    }, ownerState.anchorOrigin.horizontal === 'right' && {
      right: 24,
      left: 'auto'
    })
  });
});
const Snackbar = /*#__PURE__*/react.forwardRef(function Snackbar(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiSnackbar'
  });
  const theme = (0,useTheme/* default */.Z)();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };

  const {
    action,
    anchorOrigin: {
      vertical,
      horizontal
    } = {
      vertical: 'bottom',
      horizontal: 'left'
    },
    autoHideDuration = null,
    children,
    className,
    ClickAwayListenerProps,
    ContentProps,
    disableWindowBlurListener = false,
    message,
    onBlur,
    onClose,
    onFocus,
    onMouseEnter,
    onMouseLeave,
    open,
    resumeHideDuration,
    TransitionComponent = Grow/* default */.Z,
    transitionDuration = defaultTransitionDuration,
    TransitionProps: {
      onEnter,
      onExited
    } = {}
  } = props,
        TransitionProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props.TransitionProps, Snackbar_excluded),
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    anchorOrigin: {
      vertical,
      horizontal
    }
  });

  const classes = Snackbar_useUtilityClasses(ownerState);
  const timerAutoHide = react.useRef();
  const [exited, setExited] = react.useState(true);
  const handleClose = (0,utils_useEventCallback/* default */.Z)((...args) => {
    if (onClose) {
      onClose(...args);
    }
  });
  const setAutoHideTimer = (0,utils_useEventCallback/* default */.Z)(autoHideDurationParam => {
    if (!onClose || autoHideDurationParam == null) {
      return;
    }

    clearTimeout(timerAutoHide.current);
    timerAutoHide.current = setTimeout(() => {
      handleClose(null, 'timeout');
    }, autoHideDurationParam);
  });
  react.useEffect(() => {
    if (open) {
      setAutoHideTimer(autoHideDuration);
    }

    return () => {
      clearTimeout(timerAutoHide.current);
    };
  }, [open, autoHideDuration, setAutoHideTimer]); // Pause the timer when the user is interacting with the Snackbar
  // or when the user hide the window.

  const handlePause = () => {
    clearTimeout(timerAutoHide.current);
  }; // Restart the timer when the user is no longer interacting with the Snackbar
  // or when the window is shown back.


  const handleResume = react.useCallback(() => {
    if (autoHideDuration != null) {
      setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }
  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);

  const handleFocus = event => {
    if (onFocus) {
      onFocus(event);
    }

    handlePause();
  };

  const handleMouseEnter = event => {
    if (onMouseEnter) {
      onMouseEnter(event);
    }

    handlePause();
  };

  const handleBlur = event => {
    if (onBlur) {
      onBlur(event);
    }

    handleResume();
  };

  const handleMouseLeave = event => {
    if (onMouseLeave) {
      onMouseLeave(event);
    }

    handleResume();
  };

  const handleClickAway = event => {
    if (onClose) {
      onClose(event, 'clickaway');
    }
  };

  const handleExited = node => {
    setExited(true);

    if (onExited) {
      onExited(node);
    }
  };

  const handleEnter = (node, isAppearing) => {
    setExited(false);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  };

  react.useEffect(() => {
    // TODO: window global should be refactored here
    if (!disableWindowBlurListener && open) {
      window.addEventListener('focus', handleResume);
      window.addEventListener('blur', handlePause);
      return () => {
        window.removeEventListener('focus', handleResume);
        window.removeEventListener('blur', handlePause);
      };
    }

    return undefined;
  }, [disableWindowBlurListener, handleResume, open]);
  react.useEffect(() => {
    if (!open) {
      return undefined;
    }
    /**
     * @param {KeyboardEvent} nativeEvent
     */


    function handleKeyDown(nativeEvent) {
      if (!nativeEvent.defaultPrevented) {
        // IE11, Edge (prior to using Bink?) use 'Esc'
        if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
          // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
          if (onClose) {
            onClose(nativeEvent, 'escapeKeyDown');
          }
        }
      }
    }

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [exited, open, onClose]); // So we only render active snackbars.

  if (!open && exited) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ClickAwayListener_ClickAwayListener, (0,esm_extends/* default */.Z)({
    onClickAway: handleClickAway
  }, ClickAwayListenerProps, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(SnackbarRoot, (0,esm_extends/* default */.Z)({
      className: (0,clsx_m/* default */.Z)(classes.root, className),
      onBlur: handleBlur,
      onFocus: handleFocus,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      ownerState: ownerState,
      ref: ref // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
      // See https://github.com/mui/material-ui/issues/29080
      ,
      role: "presentation"
    }, other, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,esm_extends/* default */.Z)({
        appear: true,
        in: open,
        timeout: transitionDuration,
        direction: vertical === 'top' ? 'down' : 'up',
        onEnter: handleEnter,
        onExited: handleExited
      }, TransitionProps, {
        children: children || /*#__PURE__*/(0,jsx_runtime.jsx)(SnackbarContent_SnackbarContent, (0,esm_extends/* default */.Z)({
          message: message,
          action: action
        }, ContentProps))
      }))
    }))
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Snackbar_Snackbar = (Snackbar);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Alert/Alert.js + 6 modules
var Alert = __webpack_require__(82741);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AlertTitle/AlertTitle.js + 1 modules
var AlertTitle = __webpack_require__(38391);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(22841);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(7258);
// EXTERNAL MODULE: ./src/@types/global.ts
var global = __webpack_require__(45343);
;// CONCATENATED MODULE: ./src/components/login/LoginForm/LoginForm.schema.ts


var loginSchema = function(manager, t) {
    var type = global/* LoginType.TALLERB */.Bz.TALLERB;
    if (manager) {
        type = global/* LoginType.TALLERB_R */.Bz.TALLERB_R;
    }
    var defaultUsername = "", defaultPassword = "";
    if (false) {}
    return es/* object */.Ry().shape({
        type: es/* string */.Z_().required().default(type),
        username: es/* string */.Z_().min(1, "Username must be at least 1 character").max(10, "Username must be at most 10 characters").required().default(defaultUsername),
        password: es/* string */.Z_().required().default(defaultPassword)
    });
};

;// CONCATENATED MODULE: ./src/components/login/LoginForm/LoginForm.tsx
















var LoginForm = function(param) {
    var _manager = param.manager, manager = _manager === void 0 ? false : _manager;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), hasErrors = ref[0], setHasErrors = ref[1];
    var schema = loginSchema(manager, t);
    var ref1 = (0,index_esm/* useForm */.cI)({
        mode: "onChange",
        reValidateMode: "onChange",
        defaultValues: schema.getDefaultFromShape(),
        resolver: (0,yup/* yupResolver */.X)(schema)
    }), handleSubmit = ref1.handleSubmit, control = ref1.control, errors = ref1.formState.errors;
    var ref2 = (0,_sliced_to_array/* default */.Z)(hooks_useLogin({
        onError: function(e) {
            setHasErrors(true);
            // rethrow error as-is
            throw e;
        }
    }), 2), login = ref2[0], ref3 = ref2[1], loading = ref3.loading, error = ref3.error;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                // Saves the username from the last login attempt and updates the reactive var
                // FIXME: This should be provided by the REST service.
                (0,cookies/* writeToCookies */.kD)(constants/* StorageTokens.USERNAME */.Gr.USERNAME, data.username, {
                    expires: constants/* AuthCookieExpiration */.JG
                });
                (0,cookies/* writeToCookies */.kD)(constants/* StorageTokens.IS_MANAGER */.Gr.IS_MANAGER, manager, {
                    expires: constants/* AuthCookieExpiration */.JG
                });
                (0,cookies/* writeToCookies */.kD)(constants/* StorageTokens.SELECTED_WORKSHOP */.Gr.SELECTED_WORKSHOP, +data.username);
                (0,graphql_cache/* usernameVar */.$7)(data.username);
                (0,graphql_cache/* isManagerVar */.st)(manager);
                login({
                    variables: (0,src_object_spread/* default */.Z)({}, data)
                }).catch(function() {});
                return [
                    2
                ];
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "column",
        children: [
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar_Snackbar, {
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                open: hasErrors,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert/* default */.Z, {
                    severity: "error",
                    sx: {
                        "& .MuiAlert-message": {
                            maxWidth: 285,
                            wordBreak: "break-word"
                        }
                    },
                    title: error.message,
                    action: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        size: "small",
                        "aria-label": "close",
                        color: "inherit",
                        onClick: function() {
                            return setHasErrors(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            name: "CloseS"
                        })
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertTitle/* default */.Z, {
                            children: "Error"
                        }),
                        " ",
                        error.message
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                component: "form",
                id: "login-form",
                sx: {
                    display: "flex",
                    flexDirection: "column"
                },
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            typography: "h3",
                            fontWeight: 500,
                            mb: 0.75
                        },
                        children: t("INICIAR_SESION")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            typography: "body1",
                            color: "grey.700",
                            mb: 3
                        },
                        children: t("CREDENCIALES_ACCESO")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                        control: control,
                        name: "username",
                        render: function(param) {
                            var _field = param.field, onChange = _field.onChange, value = _field.value;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* TextField */.n, {
                                onChange: onChange,
                                value: value,
                                error: hasErrors || !!errors.username,
                                required: true,
                                name: "username",
                                label: t("USUARIO"),
                                autoComplete: "username",
                                id: "username",
                                sx: {
                                    mb: 1.5
                                },
                                variant: "outlined",
                                helperText: errors.username && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    component: "span",
                                    direction: "row",
                                    alignItems: "flex-start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            component: "span",
                                            sx: {
                                                flexShrink: 0,
                                                position: "relative",
                                                top: 1,
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: 14,
                                                height: 14,
                                                marginRight: 0.5,
                                                backgroundColor: "error.main",
                                                borderRadius: 50
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                name: "CloseS",
                                                sx: {
                                                    fontSize: 10,
                                                    path: {
                                                        fill: function(theme) {
                                                            return theme.palette.common.white;
                                                        }
                                                    }
                                                }
                                            })
                                        }),
                                        errors.username.message
                                    ]
                                }),
                                disabled: loading
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                        control: control,
                        name: "password",
                        defaultValue: "",
                        render: function(param) {
                            var _field = param.field, onChange = _field.onChange, value = _field.value;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* TextField */.n, {
                                onChange: onChange,
                                value: value,
                                error: hasErrors,
                                type: "password",
                                required: true,
                                name: "password",
                                label: t("CONTRASE\xd1A"),
                                autoComplete: "current-password",
                                id: "password",
                                variant: "outlined",
                                disabled: loading,
                                InputLabelProps: {
                                    shrink: true
                                }
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_Checkbox_Checkbox, {
                            disabled: loading
                        }),
                        label: "Recordar datos",
                        sx: {
                            mt: 0.5
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        type: "submit",
                        form: "login-form",
                        variant: "contained",
                        color: "primary",
                        size: "large",
                        loading: loading,
                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            name: "ArrowRightS"
                        }),
                        sx: {
                            mt: 1.5
                        },
                        children: t("CONTINUAR")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LoginForm_LoginForm = (LoginForm);

;// CONCATENATED MODULE: ./src/components/login/LoginForm/index.ts


// EXTERNAL MODULE: ./src/config/index.ts + 9 modules
var config = __webpack_require__(15565);
;// CONCATENATED MODULE: ./src/components/login/LoginView.tsx









var PageDefault = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 45498));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45498)
            ];
        }
    }
});
var LoginViewHead = (0,styled/* default */.ZP)(Grid/* default */.ZP, {
    name: "LoginView",
    slot: "Head"
})({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between"
});
var LoginView = function(param) {
    var _manager = param.manager, manager = _manager === void 0 ? false : _manager;
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        flexGrow: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "column",
                justifyContent: "space-between",
                sx: (0,src_object_spread/* default */.Z)({
                    flexGrow: 0,
                    flexBasis: 375,
                    p: 5,
                    pb: 3,
                    bgcolor: "background.paper"
                }, isMobile && {
                    flexBasis: "100%"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoginViewHead, {
                        container: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Brand/* Brand */.H, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginLangDropdown_LoginLangDropdown, {
                                manager: manager
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        direction: "column",
                        flexGrow: 1,
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginForm_LoginForm, {
                            manager: manager
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        alignSelf: "stretch",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "caption",
                                sx: {
                                    fontWeight: 500
                                },
                                children: [
                                    "\xa9 ",
                                    new Date().getFullYear(),
                                    " MAYORAL MODA INFANTIL S.A.U."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "caption",
                                sx: {
                                    fontWeight: 500,
                                    color: "grey.600"
                                },
                                children: [
                                    "v",
                                    config/* default.public.version */.Z["public"].version
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageDefault, {})
        ]
    });
};
/* harmony default export */ var login_LoginView = (LoginView);


/***/ }),

/***/ 86440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ TextField_TextField; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TextField/TextField.js + 3 modules
var TextField = __webpack_require__(77169);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(9041);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mayoral/ui/Icon/Icon.tsx
var Icon = __webpack_require__(77166);
;// CONCATENATED MODULE: ./node_modules/@mayoral/ui/TextField/TextField.parts.tsx







var TogglePasswordLegibility = function(_param) {
    var legible = _param.legible, props = (0,_object_without_properties/* default */.Z)(_param, [
        "legible"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-label": "toggle password visibility",
        title: legible ? "Hide password" : "Show password",
        edge: "end"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
            name: legible ? "HideS" : "ShowS"
        })
    }));
};

;// CONCATENATED MODULE: ./node_modules/@mayoral/ui/TextField/TextField.tsx







function getFieldType(type) {
    var legible = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (type === "password" && legible) {
        return "text";
    }
    return type;
}
var TextField_TextField = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var type = _param.type, props = (0,_object_without_properties/* default */.Z)(_param, [
        "type"
    ]);
    var _$ref = (0,react.useState)(type !== "password"), legible = _$ref[0], setLegible = _$ref[1];
    var computedType = (0,react.useMemo)(function() {
        return getFieldType(type, legible);
    }, [
        type,
        legible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        ref: ref,
        type: computedType,
        InputProps: (0,_object_spread/* default */.Z)({}, props.InputProps, type === "password" ? {
            endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TogglePasswordLegibility, {
                    legible: legible,
                    onClick: function() {
                        return setLegible(!legible);
                    }
                })
            })
        } : {})
    }));
});


/***/ })

}]);